var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolTypes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.075 4.925 17.25v-6L.825 9 12 2.9 23.175 9v8.1H21v-6.9l-1.925 1.05v6Zm0-8.5L18.625 9 12 5.425 5.375 9Zm0 6.025 4.9-2.65V12.4L12 15.1l-4.9-2.7v3.55Zm0-6.025Zm0 2.35Zm0 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolTypes);
export default __webpack_public_path__ + "static/media/school_types.2fdaf4deb013b5ddb2774ec08af0d0d3.svg";
export { ForwardRef as ReactComponent };